export const COLUMN_PARAMS_LIST = [
	{ key: "length_of_rental", label: "LOR" },
	{ key: "car_description", label: "Car Model", filterType: "textField" },
	{ key: "acriss_code", label: "Acriss", filterType: "dropdown" },
	{ key: "automatic_translation", label: "Transmission" },
	{ key: "id_category", label: "Category", filterType: "dropdown" },
	{ key: "unlimited_km_translation", label: "Mileage" },
	{ key: "id_master_provider_translation", label: "Provider", filterType: "dropdown", providerLogo: true },
	{ key: "is_prepaid_translation", label: "Payment method" },
	{ key: "seats", label: "Seats", filterType: "dropdown", display: false },
	{ key: "doors", label: "Doors", filterType: "dropdown", display: false },
	{ key: "rating", label: "Rating", filterType: "dropdown", display: false },
	{ key: "position", label: "Position", filterType: "dropdown", display: false, displayFilters: false },
	{ key: "in_terminal_pickup_translation", label: "In terminal", filterType: "dropdown", display: false },
	{ key: "special_offer", label: "Special offer", filterType: "dropdown", display: false },
	{ key: "luggage_big", label: "Big suitcase", filterType: "dropdown", display: false },
	{ key: "id_master_web_supplier_translation", label: "Web supplier", filterType: "dropdown", display: false },
	{ key: "luggage_small", label: "Small suitcase", filterType: "dropdown", display: false },
	{ key: "included_km", label: "Mileage included", filterType: "dropdown", display: false },
	{ key: "id_fuel_policy_translation", label: "Fuel policy", filterType: "dropdown", display: false },
	{ key: "id_insurance_translation", label: "Insurance", filterType: "dropdown", display: false },
	{ key: "raw_insurance", label: "Web insurance", filterType: "dropdown", display: false },
]